import React from "react";
import { Navigate, useLocation } from "react-router-dom";

// URL du QR : https://mad-up-academy.com/activer?sn=...&t=... (sans langue, l'IHM
// de l'appareil ne la connait pas forcement). On choisit la langue du telephone
// (fr, es, sinon en) et on garde les parametres.
const ActivationRedirect = () => {
  const { search } = useLocation();
  let langue = "en";
  try {
    const l = ((navigator.languages && navigator.languages[0]) || navigator.language || "en").toLowerCase();
    if (l.startsWith("fr")) langue = "fr";
    else if (l.startsWith("es")) langue = "es";
  } catch (e) { /* en */ }
  return <Navigate replace to={`/${langue}/activer${search}`} />;
};

export default ActivationRedirect;
